import { purify } from "../../../_src/components/purify";

export function searchEstimates() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")

    function search(loadMore) {
        var form = document.querySelector('#filter-estimates');
        var data = new FormData(form);
        btnLoadMore = document.querySelector("[data-action=load-more]")

        if (btnLoadMore) {
            btnLoadMore.classList.add("loading")
            btnLoadMore.classList.remove("hidden")
        }

        if (!loadMore) {
            document.querySelector("#result-estimates").innerHTML = "";
            document.querySelector(".loader-estimates").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-estimates fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        fetch(`/ifag/dados-e-analises/ajax/estimates.html/p${ btnLoadMore ? btnLoadMore.getAttribute("data-page") : 1 }?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-content").insertAdjacentHTML('beforebegin', response);
            } else {
                document.querySelector("#result-estimates").innerHTML = purify(response);
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore = document.querySelector("[data-action=load-more]")

            if (btnLoadMore) {
                btnLoadMore.classList.remove("loading")

                if (parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.total)) {
                    btnLoadMore.classList.add('hidden');
                }

                if (!loadMore) {
                    btnLoadMore.addEventListener("click", function() {
                        search(true);
                        btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1
                    });
                }
            }

            if (!loadMore) {
                document.querySelector(".loader-estimates").classList.add("hidden")
            }

            document.querySelectorAll("#filter-estimates fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() {
            search(true);
            btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1
        });
    }

    document.querySelector("#filter-estimates").addEventListener("change", function(event) { event.preventDefault(), setTimeout(() => { search(false) }, 100), btnLoadMore ? btnLoadMore.dataset.page = "1" : '' }, false);
}

if (document.querySelector("#filter-estimates")) {
    searchEstimates();
}
